"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-roberto": {
    "fa041f52": [{
      "hkey": "b7e79ef7",
      "slug": "san-roberto",
      "name": "San Roberto",
      "primary": true,
      "skipSearch": false
    }],
    "acquacalda": [{
      "hkey": "b7e79ef7",
      "slug": "san-roberto",
      "name": "San Roberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b6bf6ce4": [{
      "hkey": "b7e79ef7",
      "slug": "san-roberto",
      "name": "San Roberto",
      "primary": true,
      "skipSearch": false
    }],
    "colelli": [{
      "hkey": "b7e79ef7",
      "slug": "san-roberto",
      "name": "San Roberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "162d7360": [{
      "hkey": "b7e79ef7",
      "slug": "san-roberto",
      "name": "San Roberto",
      "primary": true,
      "skipSearch": false
    }],
    "favani": [{
      "hkey": "b7e79ef7",
      "slug": "san-roberto",
      "name": "San Roberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90615b66": [{
      "hkey": "b7e79ef7",
      "slug": "san-roberto",
      "name": "San Roberto",
      "primary": true,
      "skipSearch": false
    }],
    "melia": [{
      "hkey": "b7e79ef7",
      "slug": "san-roberto",
      "name": "San Roberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "860f1ccd": [{
      "hkey": "b7e79ef7",
      "slug": "san-roberto",
      "name": "San Roberto",
      "primary": true,
      "skipSearch": false
    }],
    "samperi": [{
      "hkey": "b7e79ef7",
      "slug": "san-roberto",
      "name": "San Roberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "86e130b5": [{
      "hkey": "b7e79ef7",
      "slug": "san-roberto",
      "name": "San Roberto",
      "primary": true,
      "skipSearch": false
    }],
    "san-giorgio-rumia": [{
      "hkey": "b7e79ef7",
      "slug": "san-roberto",
      "name": "San Roberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;